import {
    EXIBIR_DOC,
    EXIBIR_DOC_SUCCESS,
    EXIBIR_DOC_FAIL,

    ARQUIVO,
    ARQUIVO_SUCCESS,
    ARQUIVO_FAIL,
    
    LIMPA_MSG,

    SIG_CONTATAR,
    SIG_CONTATAR_SUCCESS,
    SIG_CONTATAR_FAIL,
    ADD_STATE
} from './types'
import api from './api';

export const exibirDocumento = ( id ) => {
    return dispatch => {

        dispatch({ type: EXIBIR_DOC })

        api.get(`/documentos/exibir/${id}`,{
            responseType: 'arraybuffer',
            dataType:'blob'
        }).then( res => {
            dispatch({ type: EXIBIR_DOC_SUCCESS, payload: res.data })

        }).catch( err => {
            var msg = ''
            if(err.response != undefined) {
                err = err.response.data
                msg  = err.message
            }

            dispatch({ type: EXIBIR_DOC_FAIL, payload: msg })
        })
    }
}

export const salvarArquivo = (dados, callback) => {
    return async dispatch => {
        dispatch({ type: ARQUIVO })

        var params = new FormData()
    
        for (let i in dados) {
            params.append(i,dados[i])
        }
        console.log('=> DADOS ENVIADOS: ', dados);
        
        api.post('arquivo', params).then( res => {
            console.log('=> RESPOSTA: ', res);
            dispatch({ type: ARQUIVO_SUCCESS, payload: res.data.message })
            callback(false)
        }).catch( err => {
            console.log('=> ERRO: ', err);
            var msg = 'Error! tente novamente mais tarde.'
            if(err.response) {
                msg = err.response.data.message
            }
            
           dispatch({ type: ARQUIVO_FAIL, payload: msg })
           callback(true)
        })
    }

}

export const limpaMsg = () => { return dispatch => dispatch({ type: LIMPA_MSG})}

export const enviarEmailSig = (doc_id,sig_id) => {
    return dispatch => {

        dispatch({ type: SIG_CONTATAR })
        
        let param = new FormData()
        param.append('signatario_id',sig_id)
        param.append('documento_id',doc_id)

        api.post(`signatario/sendEmail`,param).then( res => {
            dispatch({ type: SIG_CONTATAR_SUCCESS, payload: res.data.message })
           // callback(res.data.erro)
        }).catch( err => {
            var msg = 'Error! tente novamente mais tarde.'

            if(err.response != undefined) {
                msg = err.response.data.message
               // callback(true)
            }
            dispatch({ type: SIG_CONTATAR_FAIL, payload: msg })


        })
    }
}

export const addState = (payload) => {
    return dispatch => {
        dispatch({ type: ADD_STATE, payload })
    }
}